import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TrackCatalogParams } from '@app/models/tracking/track-event-param-type';
import { CatalogLogoImgComponent } from "@commonComponents/catalog-logo-img/catalog-logo-img.component";
import { LoadingComponent } from '@commonComponents/loading/loading.component';
import { NgbTooltipModule } from '@commonNodeModules/@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@commonNodeModules/@ngx-translate/core';
import { CatalogContentType } from '@enums/CatalogContentType';
import { CatalogSearchResultDisplayType } from '@enums/catalog-search-result-display-type';
import { CatalogViewCatalogInformationDto, CatalogViewForeignLanguageCatalogsDto, CatalogViewRelatedCatalogsDto } from '@interfaces/HttpClient/CatalogApiPublicModels';
import { IBreadcrumb } from '@interfaces/iBreadcrumb';
import { ICatalogQueryParams, ICatalogRoutingParams } from '@interfaces/iCatalogRoutingParams';
import { TagModel } from '@interfaces/iTagFilter';
import { AnalyticsTrackingFacadeService } from '@services/analytics-tracking-facade.service';
import { CatalogSearchresultModel } from '@services/search-result.service';
import { BreadcrumbComponent } from "../../../components/breadcrumb/breadcrumb.component";
import { CatalogNavigationComponent } from "../catalog-navigation/catalog-navigation.component";
import { CatalogSearchresultComponent } from "../catalog-searchresult/catalog-searchresult.component";
import { CatalogTreeComponent } from "../catalog-tree/catalog-tree.component";

@Component({
	selector: 'app-catalog-desktop-navigation',
	templateUrl: './catalog-desktop-navigation.component.html',
	styleUrls: ['./catalog-desktop-navigation.component.scss', '../resize-toggle-button.scss'],
	providers: [],
	imports: [
		NgClass,
		TranslatePipe,
		RouterModule,
		NgbTooltipModule,
		BreadcrumbComponent,
		CatalogNavigationComponent,
		LoadingComponent,
		CatalogLogoImgComponent, CatalogTreeComponent, CatalogSearchresultComponent
	]
})
export class CatalogDesktopNavigationComponent implements OnInit {

	constructor(
		private trackingFacadeService: AnalyticsTrackingFacadeService
	) {
	}
	@Input() minimizedFilter = false;
	@Input() canNavigateToStartingPage = false;
	@Input() hasTree = false;
	@Input() breadcrumbs: IBreadcrumb[] = [];
	@Input() catalog: CatalogViewCatalogInformationDto;
	@Input() languageCatalogs: CatalogViewForeignLanguageCatalogsDto[];
	@Input() relatedCatalogs: CatalogViewRelatedCatalogsDto[];
	@Input() currentRoutingParams: ICatalogRoutingParams;
	@Input() currentQueryParams: ICatalogQueryParams;
	@Input() catalogSearchResultModel: CatalogSearchresultModel = { catalogFilterEntries: [], displayType: CatalogSearchResultDisplayType.Catalog, isEmptySearch: false, searchTags: [] };
	@Input() defaultTags: TagModel[];
	@Input() selectedTags: TagModel[];
	@Input() tags: TagModel[];
	@Input() categoryGroups: { title: string, id: number }[];
	@Input() catalogHeaderSelected = true;
	@Input() rootLink: string[];
	@Input() categoryTooltip: string
	@Input() categoriesText: string
	@Input() titleToolTip: string;
	@Output() openNews = new EventEmitter<number>();
	@Output() emptySearch = new EventEmitter();

	public catalogContentType = CatalogContentType;

	ngOnInit(): void {
	}

	public toggleFilterSize() {
		this.minimizedFilter = !this.minimizedFilter;
	}

	public async onCatalogHeaderClick() {

		this.trackingFacadeService.handleTrackEvent(new TrackCatalogParams(this.catalog?.key, true))
	}

}
